import React, { Component } from 'react'
import { ThemeProvider } from 'react-bootstrap'
import { Box, Paper, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import CircularProgress from '@material-ui/core/CircularProgress'
import Moment from 'react-moment'
import Cancel from '@material-ui/icons/Cancel'

import { theme } from '../../classes/Themes'
import GlobalAttentionHeaderComponent from './GlobalAttentionHeaderComponent'
import GlobalAttentionDistributorComponent from './GlobalAttentionDistributorsComponent'
import './GlobalAttentionComponent.scss'
import './../subscriber/SubscriberComponent.scss'
import GlobalAttentionEngagementComponent from './GlobalAttentionEngagementComponent'
import GlobalAttentionGenreComponent from './GlobalAttentionGenreComponent'
import GlobalAttentionMetricsTable from './GlobalAttentionMetricsTable'
import { ANTICIPATION_INDEX, CANCELLED_SHOWS_INDEX, TOP_CONTENT_INDEX, TRENDING_INDEX } from '../../constants/commons'
import GlobalAttentionOnBoarding from './GlobalAttentionOnBoarding'
import NotFound from '../NotFound'

export class GlobalAttentionComponent extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    homepage: PropTypes.object,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string
    }),
    attentionIndexDetails: PropTypes.object,
    engagementWeeks: PropTypes.array,
    fetchAnticipationIndexDetails: PropTypes.func,
    fetchTopContentIndexDetails: PropTypes.func,
    fetchTrendingIndexDetails: PropTypes.func,
    fetchCancelledShowsDetails: PropTypes.func,
    fetchGlobalAttentionScoreDetails: PropTypes.func,
    setSelectedAttentionIndexDate: PropTypes.func,
    setSelecteddAttentionIndexView: PropTypes.func,
    selectedDate: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      screenWidth: window.innerWidth,
      networksByEngagement: null,
      distributorByEngagement: null,
      titlesByGenre: null,
      selectedDistributions: [],
      selectedPlatforms: [],
      selectedGenres: [],
      dateIndex: 0,
      selectedView: TOP_CONTENT_INDEX
    }
  }

  setSelectedDistributions = (distribution) => {
    let distributionList = this.state.selectedDistributions
    const index = distributionList.indexOf(distribution)
    if (index === -1) {
      distributionList.push(distribution)
    } else {
      distributionList.splice(index, 1)
    }
    this.setState({
      selectedDistributions: distributionList
    })
  }

  setSelectedPlatforms = (platform) => {
    let platformList = this.state.selectedPlatforms
    const index = platformList.indexOf(platform)
    if (index === -1) {
      platformList.push(platform)
    } else {
      platformList.splice(index, 1)
    }
    this.setState({
      selectedPlatforms: platformList
    })
  }

  setSelectedGenres = (genre) => {
    let genreList = this.state.selectedGenres
    const index = genreList.indexOf(genre)
    if (index === -1) {
      genreList.push(genre)
    } else {
      genreList.splice(index, 1)
    }
    this.setState({
      selectedGenres: genreList
    })
  }

  setDateIndex = (index) => {
    this.setState ({ dateIndex: index })
    const selectedWeek = this.props.engagementWeeks[index]
    const previousWeek = index != this.props.engagementWeeks.length - 1 ? this.props.engagementWeeks[index + 1] : selectedWeek
    switch (this.state.selectedView) {
      case ANTICIPATION_INDEX:
        this.props.fetchAnticipationIndexDetails(selectedWeek.startDateOfWeek, selectedWeek.endDateOfWeek)
        break
      case TOP_CONTENT_INDEX:
        this.props.fetchTopContentIndexDetails(selectedWeek.startDateOfWeek, selectedWeek.endDateOfWeek)
        break
      case TRENDING_INDEX:
        this.props.fetchTrendingIndexDetails(selectedWeek.startDateOfWeek, selectedWeek.endDateOfWeek, previousWeek.startDateOfWeek, previousWeek.endDateOfWeek)
        break
      case CANCELLED_SHOWS_INDEX:
        this.props.fetchCancelledShowsDetails(selectedWeek.startDateOfWeek, selectedWeek.endDateOfWeek)
        break
    }
    this.props.setSelectedAttentionIndexDate(selectedWeek.startDateAndEndDate)
  }

  setSelectedView = (view) => {
    this.setState({ selectedView: view })
    this.props.setSelecteddAttentionIndexView(view)
    const date = this.props.selectedDate.split('_')
    const previousWeek = this.state.dateIndex != this.props.engagementWeeks.length - 1 ? this.props.engagementWeeks[this.state.dateIndex + 1] : this.props.engagementWeeks[this.state.dateIndex]
    switch (view) {
      case ANTICIPATION_INDEX:
        this.props.fetchAnticipationIndexDetails(date[0], date[1])
        break
      case TOP_CONTENT_INDEX:
        this.props.fetchTopContentIndexDetails(date[0], date[1])
        break
      case TRENDING_INDEX:
        this.props.fetchTrendingIndexDetails(date[0], date[1], previousWeek.startDateOfWeek, previousWeek.endDateOfWeek)
        break
      case CANCELLED_SHOWS_INDEX:
        this.props.fetchCancelledShowsDetails(date[0], date[1])
        break
    }
  }

  _renderShortcut () {
    if (!this.props.shortcut || this.state.hideShortcutBanner) {
      return null
    }

    const expires = this.props.shortcut.expires_at
    const click = e => {
      e.preventDefault()
      this.setState({ hideShortcutBanner: true })
    }

    return (
      <div className='shortCutBanner'>
        <span>
          <span>This preview of <strong>Attention Index</strong> will expire on&nbsp;</span>
          <Moment format='MM/DD/YYYY'>{expires}</Moment>
        </span>
        <span onClick={click}><Cancel /></span>
      </div>
    )
  }

  handleTourCallBack = () => {
    this.setState({tourFinished: true})
  }
  _renderOnboarding () {
    if (!this.props.shortcut) {
      return null
    }
    return (
      <GlobalAttentionOnBoarding
        run={true}
        setScroll={this._setScroll.bind(this)}
        />
    )
  }

  _setScroll () {
    window.scrollTo({
      top: this.scrollRef.current.offsetTop + 200
    })
  }

  render () {
    if (!this.props.shortcut && this.props.homepage && this.props.homepage.details && !this.props.homepage.details.is_attention_index) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }
    return (
      <ThemeProvider theme={theme}>
        <Box className='rightSide globalAttentionIndex'>
          {this._renderShortcut()}
          {this._renderOnboarding()}
          <Box className='headerMenu' id='headerMenu'>
            <GlobalAttentionHeaderComponent
              selectedView={this.state.selectedView}
              setSelectedView={this.setSelectedView}
            />
            <Box className='marketModalWrapper'>
              <Box className='topRightActionWrap'>
                {/* <Box className='export-icon'/> */}
                <Box className='datePicker'>
                  <img className={this.state.dateIndex == this.props.engagementWeeks.length -1 ? 'cursorPointer disabledImage' : 'cursorPointer enabledImage'} src="/static/images/arrow_left.svg" alt="info" onClick={() => this.setDateIndex(this.state.dateIndex + 1)}/>
                  <span className='dateText'>{this.props.engagementWeeks.length > 0 && this.props.engagementWeeks[this.state.dateIndex].displayDate}</span>
                  <img className={this.state.dateIndex == 0 ? 'cursorPointer disabledImage' : 'cursorPointer enabledImage'} src="/static/images/arrow_right.svg" alt="info" onClick={() => this.setDateIndex(this.state.dateIndex - 1)}/>
                </Box>
              </Box>
            </Box>
          </Box>
          { this.props.attentionIndexDetails && this.props.attentionIndexDetails.isFetching &&
            <Row className='attentionIndexLoader'>
              <CircularProgress />
            </Row>
          }
          { this.props.attentionIndexDetails && this.props.attentionIndexDetails.details &&
          <Row className='rowSpacing metricSection'>
            <Col>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={4} md={6} sm={12} className='modulePadding'>
                  <GlobalAttentionDistributorComponent
                    screenWidth={this.state.screenWidth}
                    selectedDistributions={this.state.selectedDistributions}
                    setSelectedDistributions={this.setSelectedDistributions}
                    attentionIndexDetails={this.props.attentionIndexDetails} />
                </Grid>
                <Grid item xs={12} lg={4} md={6} sm={12} className='modulePadding'>
                  <GlobalAttentionEngagementComponent
                    screenWidth={this.state.screenWidth}
                    selectedPlatforms={this.state.selectedPlatforms}
                    setSelectedPlatforms={this.setSelectedPlatforms}
                    attentionIndexDetails={this.props.attentionIndexDetails} />
                </Grid>
                <Grid item xs={12} lg={4} md={6} sm={12} className='modulePadding'>
                  <GlobalAttentionGenreComponent
                    screenWidth={this.state.screenWidth}
                    selectedGenres={this.state.selectedGenres}
                    setSelectedGenres={this.setSelectedGenres}
                    attentionIndexDetails={this.props.attentionIndexDetails} />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12} md={12} sm={12} id='contentPerformance' className='cardWrapper'
                  style={{transition: theme.transitions.create('all', {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.leavingScreen
                 })}}>
                  <Paper className="cardBase">
                    <Grid container direction="column">
                      <Grid item className='cardPadding'>
                        <span className="cardTitle">All Content Attention Index</span>
                        <OverlayTrigger overlay={<Tooltip id="tooltip">All Content Attention Index</Tooltip>} placement="right">
                          <img src="/static/images/info.png" alt="info" className="cardInfo" />
                        </OverlayTrigger>
                      </Grid>
                      <Grid item className="cardSubTitle">Top performing content ranked by total engagement across all shows and movies</Grid>
                      <GlobalAttentionMetricsTable
                        attentionIndexDetails={this.props.attentionIndexDetails}
                        selectedDistributions={this.state.selectedDistributions}
                        selectedPlatforms={this.state.selectedPlatforms}
                        selectedGenres={this.state.selectedGenres}
                        selectedView={this.state.selectedView}
                        dateIndex={this.state.dateIndex}
                      />
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Col>
          </Row>
          }
        </Box>
      </ThemeProvider>
    )
  }
}